/**
 * Brand Configuration Registry
 *
 * Maps brand `layout` values (from the database) to frontend configuration.
 * When adding a new brand, add an entry here and create the corresponding
 * Nav component and SCSS class. See docs/brand-layouts.md for full instructions.
 */

const brandConfigs = {
    SiopAcademyLayout: {
        navComponent: () => import('@/views/layouts/default/SiopAcademyNav.vue'),
        navComponentName: 'SiopAcademyNav',
    },
    ida: {
        navComponent: () => import('@/views/layouts/default/IdaNav.vue'),
        navComponentName: 'IdaNav',
    },
    act4c: {
        navComponent: () => import('@/views/layouts/default/Act4cNav.vue'),
        navComponentName: 'Act4cNav',
    },
    // To add a new brand:
    // 'NewBrandLayout': {
    //     navComponent: () => import('@/views/layouts/default/NewBrandNav.vue'),
    //     navComponentName: 'NewBrandNav',
    // },
};

/**
 * Returns the nav component name for a given brand, or null for the default nav.
 * @param {Object|null} brand - The current brand object from the store
 * @returns {string|null} The nav component name, or null to use the default Nav
 */
export function getNavComponentName(brand) {
    if (!brand || !brand.layout) return null;
    const config = brandConfigs[brand.layout];
    return config ? config.navComponentName : null;
}

/**
 * Returns all brand nav component loaders (for dynamic component registration).
 * @returns {Object} Map of component names to async component loaders
 */
export function getBrandNavComponents() {
    const components = {};
    for (const config of Object.values(brandConfigs)) {
        components[config.navComponentName] = config.navComponent;
    }
    return components;
}

/**
 * Checks whether the current brand has a custom layout (i.e. is branded).
 * @param {Object|null} brand - The current brand object from the store
 * @returns {boolean}
 */
export function isBranded(brand) {
    if (!brand || !brand.layout) return false;
    return brand.layout in brandConfigs;
}

export default brandConfigs;
